import { api } from "common/config/api";

export const AUTH_URL = {
	authMe: `${api.withAPI}api/doctor/me`,
}